import * as React from 'react';
import { LineChart } from '@mui/x-charts/LineChart';

export default function BasicLineChart({ accessGraph }) {
    if (!accessGraph || accessGraph.length === 0) {
        return <div>No data available</div>;
    }

    const xLabels = accessGraph.map(item => {
        const date = new Date(item._id.year, item._id.month - 1);
        return date.toLocaleString('default', { month: 'short', year: 'numeric' });
    });

    const yData = accessGraph.map(item => item.count);

    return (
        <LineChart
            xAxis={[{ scaleType: 'point', data: xLabels }]}
            series={[{ data: yData }]}
            height={300}
        />
    );
}
